import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Notification } from '../notification.model';

export enum NotificationActionTypes {
  GetNotifications = '[Notification] Get Notifications',
  UpsertNotifications = '[Notification] Upsert Notifications',
  UpdateNotifications = '[Notification] Update Notifications',
  GetNotificationsFail = '[Notification] Get Notification Fail',
  ClearNotifications = '[Notification] Clear Notifications',
  UpdateNotificationsFail = '[Notification] Update Notifications Fail'
}

export class GetNotifications implements Action {
  readonly type = NotificationActionTypes.GetNotifications;

  constructor(public payload: any = null) {}
}

export class UpsertNotifications implements Action {
  readonly type = NotificationActionTypes.UpsertNotifications;

  constructor(public payload: { notifications: Notification[], isConfirm: boolean}) {}
}

export class UpdateNotifications implements Action {
  readonly type = NotificationActionTypes.UpdateNotifications;

  constructor(public payload: any = null) {}
}

export class ClearNotifications implements Action {
  readonly type = NotificationActionTypes.ClearNotifications;
}

export class GetNotificationsFail implements Action {
  readonly type = NotificationActionTypes.GetNotificationsFail;
}

export class UpdateNotificationsFail implements Action {
  readonly type = NotificationActionTypes.UpdateNotificationsFail;
}


export type NotificationActions =
 GetNotifications
 | UpsertNotifications
 | UpdateNotifications
 | ClearNotifications
 | GetNotificationsFail
 | UpdateNotificationsFail;
